import { useHistory, useRouteMatch } from "react-router";
import { DELETE_PERMISSIONS, EDIT_PERMISSIONS } from "../../../../const/URL.const";

import { OrderListItem } from "../../../orders/OrderList/OrderListItem";
import { makeStyles } from "@material-ui/core";
import React from "react";
import UserActions from "./UserActions";

import useCanUserEditMerchant from "./useCanUserEditMerchant";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../../reducers";

const useStyles = makeStyles({
    item: {
        padding: '2rem 3rem',
        margin: '1rem 0',
        marginRight: '.5rem',
        backgroundColor: '#FFFFFF',
        borderRadius: '0.75rem',
        cursor: "pointer",
        '& > div': {
            display: 'flex',
            '& > span': {
                fontStyle: 'normal',
                fontWeight: 'normal',
                fontSize: '0.9375rem',
                lineHeight: '1.625rem',
                display: 'flex',
                alignItems: 'center',
                color: '#616161',
                width: '25%',
            }
        },
    }
})

export interface IUserListRow {
    user: any;
    columns: any;
}

const UserListRow = ({
    user,
    columns
}: IUserListRow) => {
  const history = useHistory();
    const classes = useStyles();
    const { path } = useRouteMatch();
    const merchant = useSelector((state: IReduxAppState) => state.merchant);

    const { hasPermission, isLoading } = useCanUserEditMerchant(user.id);

    const handleEditUser = (e: React.MouseEvent<HTMLElement> | any) => {
      if(user.id){
        history.push(`${path}${EDIT_PERMISSIONS}/${user.id}`);
      }
    }

    const onDeleteUser = (e: React.MouseEvent<HTMLElement>) => {
      e.stopPropagation();
      history.push(`${path}${DELETE_PERMISSIONS}/${user.id}`);
    }

    return !isLoading ? (
        <div key={`UM-${user.id}`} data-component-name="UserManagementItem">
          <OrderListItem
            className={classes.item}
            order={{
              ...user,
              user_actions: user.id && <UserActions 
                onDeleteUser={onDeleteUser} 
                handleEditUser={handleEditUser} 
                hasPermission={merchant.id !== user.id && hasPermission} 
              />
            }}
            columns={columns}
            key={`user_management_list_${user.id}`}
            onClickItem={handleEditUser}
          />
        </div>
      ) : null;
}

export default UserListRow;